import { baseApiUrl, fetcher, handleError, ServerErrorResponse } from 'data_sources/constants';

export type IncompleteAcksReportParams = {
  manualId: string;
};

export const generateIncompleteAcksReport = async (
  orgId: string,
  params: IncompleteAcksReportParams,
  callback?: () => void,
  onError?: (errors: ServerErrorResponse) => void
) => {
  const url = `${baseApiUrl()}/lexipub/reports/v1/organizations/${orgId}/reports/policy-acknowledgments/pending`;
  const paramString = new URLSearchParams({
    manualId: params.manualId,
    fileType: 'XLS',
  }).toString();

  try {
    await fetcher({
      url: `${url}?${paramString}`,
      method: 'post',
      body: {},
    });
    if (callback) callback();
  } catch (err) {
    if (onError) handleError(err as Error, { onError });
  }
};

export default function useIncompleteAcksReportExport() {
  const generate = async (
    orgId: string,
    params: IncompleteAcksReportParams,
    callback?: () => void,
    onError?: (errors: ServerErrorResponse) => void
  ) => {
    await generateIncompleteAcksReport(orgId, params, callback, onError);
  };

  return {
    generate,
  };
}
